export enum AuditCompanyInformationFormLabelsEnum {
  TITLE = 'Requesting On Behalf Of',
  CLEAR = 'Clear',
  MATCH = 'Match',
  SAME_AS = 'Same as Claimant',
}
